module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs><style>.a{fill:#fff;}</style></defs><title>gettingstarted</title><rect width=\"50\" height=\"50\"></rect><path class=\"a\" d=\"M25,11.2A13.8,13.8,0,1,0,38.8,25,13.8,13.8,0,0,0,25,11.2Zm3.52,8.39a1.62,1.62,0,1,1-1.62,1.62h0A1.63,1.63,0,0,1,28.52,19.59Zm-7,0a1.62,1.62,0,1,1-1.62,1.62,1.62,1.62,0,0,1,1.62-1.62h0ZM31.9,29.65a7,7,0,0,1-13.8,0L18,29.33H32Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gettingstarted.svg
// module id = 502
// module chunks = 1